import { useState, useContext, useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';
import { Box, Grid, Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material';

import { FlexEnd } from '../../../../commonStyles';
import { UnitContext } from '../../../../context/UnitContext';
import { useAppDispatch } from '../../../../app/hooks';
import { showSuccessSnackbar } from '../../../../features/snackbar/snackbarSlice';
import { useCreateActivity } from '../../../../features/activity/activityHooks';
import { selectProject } from '../../../../features/project/projectSlice';
import { selectUser } from '../../../../features/auth/authSlice';
import { IOption } from '../../../../types/project';

const Waitlist = () => {
  const storeDispatch = useAppDispatch();
  const createActivity = useCreateActivity();
  const project = useSelector(selectProject);
  const user = useSelector(selectUser);
  const { unit, filteredDeal, setFilteredDeal } = useContext(UnitContext);
  const [waitlistChoices, setWaitlistChoices] = useState<string[]>([]);

  useEffect(() => {
    let projectOptions = project.options.map((option: IOption) => option.name);
    let combinedWaitlist = [...new Set([...filteredDeal.joinWaitlist, ...projectOptions])];
    setWaitlistChoices(combinedWaitlist);
  }, []);

  const [saveWaitlist] = useMutation(SAVEWAITLIST, {
    onCompleted: (data) => {
      createActivity({
        project: project._id,
        user: user._id,
        deal: filteredDeal._id,
        title: `Waitlist`,
        content: `Waitlist has been updated`,
      });
      storeDispatch(showSuccessSnackbar(`Waitlist has been updated`));
    },
    onError: (err) => {
      console.log(err, 'err');
    },
  });

  const handleJoinWaitlist = (title: string) => {
    let waitlist = filteredDeal.joinWaitlist.find((waitlist: string) => waitlist === title);

    if (waitlist) {
      setFilteredDeal({
        ...filteredDeal,
        joinWaitlist: filteredDeal.joinWaitlist.filter((waitlist: string) => title !== waitlist),
      });
    } else {
      setFilteredDeal({
        ...filteredDeal,
        joinWaitlist: [...filteredDeal.joinWaitlist, title],
      });
    }
  };

  return (
    <>
      {waitlistChoices.length ? (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {waitlistChoices.map((waitlist: string) => {
              return (
                <Grid item sm={6} md={4} lg={3}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={filteredDeal.joinWaitlist.find((selected: string) => waitlist === selected) ? true : false}
                          onClick={() => handleJoinWaitlist(waitlist)}
                        />
                      }
                      label={waitlist}
                    />
                  </FormGroup>
                </Grid>
              );
            })}
          </Grid>
          <FlexEnd>
            <Button
              sx={{ mr: 1 }}
              onClick={() => saveWaitlist({ variables: { _id: filteredDeal._id, record: { joinWaitlist: filteredDeal.joinWaitlist } } })}
              color="success"
              variant="contained"
            >
              Save Waitlist
            </Button>
          </FlexEnd>
        </Box>
      ) : (
        <Box>There are currently no options for this project</Box>
      )}
    </>
  );
};

const SAVEWAITLIST = gql`
  mutation dealUpdateById($_id: MongoID!, $record: UpdateByIdDealInput!) {
    dealUpdateById(_id: $_id, record: $record) {
      record {
        purchasers {
          _id
          firstName
          lastName
        }
      }
    }
  }
`;

export default Waitlist;
